var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 15.6356C11.6818 15.6356 14.6666 12.6508 14.6666 8.96891C14.6666 5.28701 11.6818 2.30225 7.99992 2.30225C4.31802 2.30225 1.33325 5.28701 1.33325 8.96891C1.33325 12.6508 4.31802 15.6356 7.99992 15.6356Z",
    stroke: "#8A8A93",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUpdate);
export default __webpack_public_path__ + "static/media/circle-update.0444854ea534340f1c93c473c49f81ca.svg";
export { ForwardRef as ReactComponent };